import {ShenZhen} from '@/api'
import { getCurrentDate } from '@/utils/util'

export default {
  computed: {
    yearRange() {
      const { s, e } = getCurrentDate()
      return `从当前年份起算近5年(${s}-${e})`
    }
  },
  methods: {
    getAjax(api, callback) {
      ShenZhen(api, {})
      .then(res => {
        callback && callback(res.data || [])
      })
    }
  }
}
